<template>
  <div class="container mt-3">
    <div class="mt-3">
      <h3 class="title mb-3">FAQ 신규</h3>
    </div>

    <Form @submit="onSubmit" :initial-values="faqInitValues" ref="faqAddFormRef" class="form">
      <b-row class="mb-4">
        <b-col cols="2">
          <div class="mb-1">
            <label for="contentsType">카테고리 <span class="required">*</span></label>
          </div>
          <Field id="faqCategoryIdx" v-model="faqInitValues.faqCategoryIdx" name="faqCategoryIdx" label="카테고리" rules="required" v-slot="{ field, errors }">
            <b-form-select v-bind="field" v-model="faqInitValues.faqCategoryIdx" :options="compFaqCategoryList" :state="errors[0] ? false : null"></b-form-select>
          </Field>
        </b-col>
        <b-col cols="10">
          <div class="mb-1">
            <label for="title">제목 <span class="required">*</span></label>
          </div>
          <Field id="title" v-model="faqInitValues.title" name="title" label="제목" rules="required" v-slot="{ field, errors }">
            <b-form-input id="title" v-model="faqInitValues.title" name="title" type="text" v-bind="field" placeholder="제목을 입력하세요" :state="errors[0] ? false : null"> </b-form-input>
          </Field>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <Field id="contents" name="contents" label="공지내용" ref="contetnsRef" v-model="faqInitValues.contents" v-slot="{ field, errors }" rules="required">
            <TinyEditor :id="'faqContents'" :editData="faqInitValues.contents" :error="errors[0]" @change="onChangeEditor"></TinyEditor>
            <input type="hidden" v-bind="field" />
          </Field>
        </b-col>
      </b-row>

      <div class="txt-right mt-3">
        <div class="d-flex justify-content-end">
          <b-button variant="primary" class="search-button me-2" @click="back">돌아가기</b-button>
          <b-button variant="primary" class="search-button" :disabled="btnLoading ? true : false" @click="onSubmit">등록</b-button>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import _ from 'lodash';
import { computed } from '@vue/runtime-core';
import { sugangFaqAddApi } from '@/api/integrateapi/index';
export default {
  setup() {
    const store = useStore();
    const faqAddFormRef = ref(null);
    const contetnsRef = ref(null);
    const btnLoading = ref(false);
    const router = useRouter();
    const faqInitValues = {
      faqCategoryIdx: 1,
      title: '',
      contents: '',
    };
    const onSubmit = async () => {
      const { validate } = faqAddFormRef.value;

      const { valid } = await validate();
      if (!valid) {
        alert('필수 값을 확인해주세요.');
        return false;
      }

      addFaq();
    };

    const onChangeEditor = data => {
      faqInitValues.contents = data.contents;
      const { validate } = contetnsRef.value;
      validate();
    };

    const addFaq = () => {
      sugangFaqAddApi(faqInitValues)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('FAQ 추가에 성공하였습니다.');
            router.back();
          } else {
            alert('FAQ 추가에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };

    const compFaqCategoryList = computed(() => {
      const copyFaqList = _.cloneDeep(store.getters.getFaqCategoryList);

      return copyFaqList;
    });

    const back = () => {
      router.back();
    };

    return {
      faqAddFormRef,
      contetnsRef,
      btnLoading,
      faqInitValues,
      onSubmit,
      compFaqCategoryList,
      onChangeEditor,
      back,
    };
  },
};
</script>

<style></style>
